import { Component, OnInit } from '@angular/core';
import { Data, DataLoaderService, ProgressBarService,SortingService, AlternateOptionsService, CommonDataService, Subscription, PriceCalculationService } from '../index'
import { SummaryService } from "../selectable-tabs/normal-screen-components/service-call-index";
@Component({
	selector: '[standard-options]',
	templateUrl: './standard-options.template.html',
	styleUrls: ['./standard-options.component.css'],
})
export class StandardOptions {
	public standardOptions: Data[];
	public currency: string;
	public stdOptionsSuggList = [];
	public selectedStdOptions: Data[] = [];
	public flag: boolean = false;

	private subscription: Subscription;
	public errMessage;
	constructor(private dataLoaderService: DataLoaderService,private sortingService: SortingService, private progressService: ProgressBarService,
		private alternateOptionsService: AlternateOptionsService, private commonDataService: CommonDataService,
		private priceCalculationService: PriceCalculationService, private summaryService: SummaryService) {
		this.currency = this.dataLoaderService.data.currencyType;
		this.standardOptions = this.dataLoaderService.data.stdOpt;
	}

	ngOnInit() {
		this.summaryService.getSelectedOptions();

		//retention service
		this.subscription = this.priceCalculationService.notifyObservableNormalComp$.subscribe((selectedOption) => {
			if (selectedOption.fromComponent == "normalStandard") {
				this.selectedStdOptions = [];
				for (let i in selectedOption.data[0]) {
					for (let j in this.standardOptions) {
						if (this.isSameStandardOption(this.standardOptions[j], selectedOption.data[0][i])) {
							this.standardOptions[j].selected = true;
							this.selectedStdOptions.unshift(this.standardOptions[j]);
						}
					}
				}
			}
		});

		//on load
		this.standardOptions.forEach(element => {
			if (element.selected === true) {
				this.selectedStdOptions.unshift(element);
			}
		});
		this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalStandard", data: [this.selectedStdOptions] });
		// this.priceCalculationService.expertModePriceCalculation();


	}

	selectStandardOption(item) {
		this.dataLoaderService.flagDictionary.loadingFlag = true;
		this.progressService.illuminateYellow();
		this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;

		let index: number = -1;
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			let returnAlternateValues = this.alternateOptionsService.getAlternateOptionsNormal(item);
			returnAlternateValues.subscribe(
				alternateResponse => {
					if (alternateResponse.suggestions[0].addedCodes.length > 0 || alternateResponse.suggestions[0].removedCodes.length > 0) {
						this.stdOptionsSuggList = alternateResponse.suggestions;
						this.commonDataService.sendSuggestion(this.stdOptionsSuggList);
						this.openAlternateScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
					else {
						this.progressService.progressBarValidation();
						for (let i in this.standardOptions) {
							if (this.isSameStandardOption(this.standardOptions[i], item)) {
								this.standardOptions[i].selected = true;
							}
						}
						this.flag = this.itemCheck(item);
						if (this.flag) {
							this.selectedStdOptions.unshift(item);
						}
						this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
					this.sortingService.sortCodes(this.standardOptions,false)
				},
				err => {
					if (err._body !== undefined) {
						this.errMessage = err._body;
						this.commonDataService.notifyErrorMsgItem(this.errMessage);
						this.openAlternateErrorScreen();
						this.dataLoaderService.flagDictionary.loadingFlag = false;
					}
				}
			);
		} else {
			for (let i in this.standardOptions) {
				if (this.isSameStandardOption(this.standardOptions[i], item)) {
					this.standardOptions[i].selected = true;
				}
			}
			this.flag = this.itemCheck(item);
			if (this.flag) {
				this.selectedStdOptions.unshift(item);
			}
		}
		 if (this.selectedStdOptions.length > 0) {
			this.priceCalculationService.notifyNormalCompItem({ fromComponent: "normalStandard", data: [this.selectedStdOptions] });
			this.priceCalculationService.notifyExpertCompItem({ fromComponent: "expertStandard", data: [this.selectedStdOptions] })
			this.priceCalculationService.normalModePriceCalculation();
		}

	}

	itemCheck(item): boolean {
		let index: number = -1;
		for (let j in this.standardOptions) {
			for (let i in this.selectedStdOptions) {
				if (this.isSameStandardOption(item, this.selectedStdOptions[i]) && this.isSameStandardOption(item, this.standardOptions[j])) {
					this.standardOptions[j].selected = false;
					this.flag = false;
					this.selectedStdOptions.splice(Number(i), 1);
					return this.flag;
				}
			}
			this.flag = true;
		}
		return this.flag;
	}


	private isSameStandardOption(firstOption: Data, secondOption: Data): boolean {
		return firstOption.code === secondOption.code && firstOption.codeType === secondOption.codeType;
	}

	openAlternateScreen() {
		if (this.dataLoaderService.vehicleInfo.urlFlag === '0' || this.dataLoaderService.vehicleInfo.urlFlag === '1') {
			this.dataLoaderService.flagDictionary.alternateErrorFlag = false;
			this.dataLoaderService.flagDictionary.alternateValidateFlag = true;
			this.progressService.illuminateRed();
		}
	}
	openAlternateErrorScreen() {
		this.dataLoaderService.flagDictionary.alternateErrorFlag = true;
		this.dataLoaderService.flagDictionary.alternateValidateFlag = false;
		this.progressService.illuminateRed();
	}
}



// WEBPACK FOOTER //
// ./src/app/components/standard-options/standard-options.component.ts